import { useEffect, useState } from "react";

import { db } from "../firebase/config";
import { sortBy } from "lodash";
import useEvent from "./useEvent";

const useAwards = () => {
  const event = useEvent();
  const [awards, setAwards] = useState<any>();

  useEffect(() => {
    const fetch = async () => {
      if (!event) {
        return;
      }

      const awardsRef = await db
        .collection("awards")
        .where("event", "==", event)
        .get();
      const awards = awardsRef.docs.map((doc) => {
        const data = doc.data();
        return data;
      });

      setAwards(sortBy(awards, ["place"]));
    };

    fetch();
  }, [event]);

  return awards;
};

export default useAwards;
